import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

const MemorialPage = () => {
    return (
        <div className="container mt-5">
            <h1 className="mb-4">Memorial Submissions</h1>
            <p className="lead">Please submit a photo and caption of your loved one using the form below.</p>
            <a className="btn btn-primary" href="https://forms.gle/CWggMkG8T6JW6az98" target="_blank" rel="noopener noreferrer">
                Submit a Memorial
            </a>
        </div>
    );
};

export default MemorialPage;